import { PatientDemographicsConstants } from '../store/patientDemographics.constants'
import { OptionsConstants } from '../../options/store/options.constants'
import { getCurrentDate } from '../../../utilities/dateTime.util'
export const patientDemographicsSchemas = [
  {
    inputKey: PatientDemographicsConstants.SET_FIRST_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRST_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRST_NAME'],
    errorMessage: {
      properties: {
        SET_FIRST_NAME: 'Must be alphanumeric with max length of 50',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_MIDDLE_INITIAL,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MIDDLE_INITIAL: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MIDDLE_INITIAL'],
    errorMessage: {
      properties: {
        SET_MIDDLE_INITIAL: 'Must be alphanumeric with max length of 1',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_LAST_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LAST_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,60}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LAST_NAME'],
    errorMessage: {
      properties: {
        SET_LAST_NAME: 'Must be alphanumeric with max length of 60',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_DOB,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DOB: {
        type: 'string',
        format: 'nemsis-dob',
      },
    },
    additionalProperties: false,
    required: ['SET_DOB'],
    errorMessage: {
      properties: {
        SET_DOB: 'Must be in the format: MM/DD/YYYY and not greater than ' + getCurrentDate(),
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_AGE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_AGE: {
        type: 'integer',
        minimum: 0,
        maximum: 200,
      },
    },
    additionalProperties: false,
    required: ['SET_AGE'],
  },

  {
    inputKey: PatientDemographicsConstants.SET_SSN,
    isNumber: false,
    type: 'object',
    properties: {
      SET_SSN: {
        type: 'string',
        pattern: '^([0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_SSN'],
    errorMessage: {
      properties: {
        SET_SSN: 'Must be in the format: NNN-NN-NNNN',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_WEIGHT,
    isNumber: true,
    type: 'object',
    properties: {
      SET_WEIGHT: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_WEIGHT'],
  },

  {
    inputKey: PatientDemographicsConstants.SET_HEIGHT,
    isNumber: true,
    type: 'object',
    properties: {
      SET_HEIGHT: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_HEIGHT'],
  },

  {
    inputKey: PatientDemographicsConstants.SET_DRIVERS_LICENSE_NUMBER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DRIVERS_LICENSE_NUMBER: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,20}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DRIVERS_LICENSE_NUMBER'],
    errorMessage: {
      properties: {
        SET_DRIVERS_LICENSE_NUMBER: 'Must be alphanumeric with max length of 20',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_PATIENT_RUN_ID,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PATIENT_RUN_ID: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,25}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PATIENT_RUN_ID'],
    errorMessage: {
      properties: {
        SET_PATIENT_RUN_ID: 'Must be alphanumeric with max length of 25',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_PATIENT_ID,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PATIENT_ID: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,25}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PATIENT_ID'],
    errorMessage: {
      properties: {
        SET_PATIENT_ID: 'Must be alphanumeric with max length of 25',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_ADDRESS_1,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS_1: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,255}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS_1'],
    errorMessage: {
      properties: {
        SET_ADDRESS_1: 'Must be alphanumeric with max length of 255',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_ADDRESS_2,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ADDRESS_2: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,255}$',
      },
    },
    additionalProperties: false,
    required: ['SET_ADDRESS_2'],
    errorMessage: {
      properties: {
        SET_ADDRESS_2: 'Must be alphanumeric with max length of 255',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_ZIP_CODE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ZIP_CODE: {
        type: 'string',
        pattern: '^([0-9][0-9][0-9][0-9][0-9]|[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_ZIP_CODE'],
    errorMessage: {
      properties: {
        SET_ZIP_CODE: 'Must be in the format: NNNNN or NNNNN-NNNN',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_CITY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CITY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,150}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CITY'],
    errorMessage: {
      properties: {
        SET_CITY: 'Must be alphanumeric with max length of 150',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_COUNTY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COUNTY: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,150}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COUNTY'],
    errorMessage: {
      properties: {
        SET_COUNTY: 'Must be alphanumeric with max length of 150',
      },
    },
  },

  {
    inputKey: OptionsConstants.SET_PHONE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PHONE: {
        type: 'string',
        pattern: '^([2-9][0-9][0-9]-[2-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_PHONE'],
    errorMessage: {
      properties: {
        SET_PHONE: 'Must be in the format: NNN-NNN-NNNN',
      },
    },
  },

  {
    inputKey: OptionsConstants.SET_EMAIL,
    isNumber: false,
    type: 'object',
    properties: {
      SET_EMAIL: {
        type: 'string',
        pattern: '^([\x20-\x7F]+@[\x20-\x7F]+)$',
      },
    },
    additionalProperties: false,
    required: ['SET_EMAIL'],
    errorMessage: {
      properties: {
        SET_EMAIL: 'Must be in the format: email@example.com',
      },
    },
  },
  {
    inputKey: PatientDemographicsConstants.SET_PHYSICIAN_FIRSTNAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PHYSICIAN_FIRSTNAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PHYSICIAN_FIRSTNAME'],
    errorMessage: {
      properties: {
        SET_PHYSICIAN_FIRSTNAME: 'Must be alphanumeric with max length of 50',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_PHYSICIAN_MIDDLENAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PHYSICIAN_MIDDLENAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PHYSICIAN_MIDDLENAME'],
    errorMessage: {
      properties: {
        SET_PHYSICIAN_MIDDLENAME: 'Must be alphanumeric with max length of 50',
      },
    },
  },

  {
    inputKey: PatientDemographicsConstants.SET_PHYSICIAN_LASTNAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PHYSICIAN_LASTNAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,60}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PHYSICIAN_LASTNAME'],
    errorMessage: {
      properties: {
        SET_PHYSICIAN_LASTNAME: 'Must be alphanumeric with max length of 60',
      },
    },
  },
]
